"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8088,9991],{

/***/ 8088:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Benefits_Benefits; }
});

// NAMESPACE OBJECT: ./components/Carousel/index.js
var Carousel_namespaceObject = {};
__webpack_require__.r(Carousel_namespaceObject);

// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(7599);
// EXTERNAL MODULE: ../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(4246);
// EXTERNAL MODULE: ../node_modules/react/index.js
var react = __webpack_require__(7378);
// EXTERNAL MODULE: ../node_modules/next/dynamic.js
var dynamic = __webpack_require__(5218);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ../node_modules/classnames/index.js
var classnames = __webpack_require__(42);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
;// CONCATENATED MODULE: ./styles/components/Product/Benefits/Benefits-tw-styles.js
/* harmony default export */ var Benefits_tw_styles = ({
    default: {
        Benefits: "Benefits h-screen relative overflow-hidden",
        mediaItems: "mediaItems",
        backgroundImage: "media bg-image w-full h-screen absolute",
        video: "media absolute",
        textWrapper: "textWrapper w-full pl-25 absolute z-20 bottom-0 pb-29% lg:pb-0 lg:top-0 lg:inset-y-auto lg:right-0 lg:pr-80 lg:pl-0",
        title: "header4 pr-25 lg:pr-0 benefitpdptitle",
        nameSection: "benefitNames header1 mt-1% lg:overflow-hidden lg:mt-2%",
        name: "header-name mr-15 pb-10 lg:relative lg:float-left cursor-pointer lg:pb-12 lg:mr-0 lg:ml-15",
        description: "description body-small mt-3% pr-25 lg:mt-5% lg:pr-0",
        gradientOverlay: "gradientOverlay absolute top-0 left-0 w-full h-full z-10",
        singleBenefit: "single-benefit",
        black: "theme-black",
        white: "theme-white",
        imgStyle: ""
    },
    BeautyCoachBenefits: {
        Benefits: "BC-benefits Benefits h-screen relative overflow-hidden",
        mediaItems: "mediaItems",
        backgroundImage: "media bg-image w-full h-screen absolute",
        video: "media absolute",
        textWrapper: "sm:text-center textWrapper w-full pl-25 absolute z-20 bottom-0 pb-29% lg:pb-0 lg:top-0 lg:inset-y-auto lg:right-0 lg:pr-80 lg:pl-0",
        title: "header4 pr-25 lg:pr-0 benefitpdptitle",
        nameSection: "benefitNames header1 mt-1% lg:overflow-hidden lg:mt-2%",
        name: "header-name mr-15 pb-10 lg:relative lg:float-left cursor-pointer lg:pb-12 lg:mr-0 lg:ml-15",
        description: "description body-small mt-3% pr-25 lg:mt-5% lg:pr-0",
        gradientOverlay: "gradientOverlay absolute top-0 left-0 w-full h-full z-10",
        singleBenefit: "single-benefit",
        black: "theme-black",
        white: "theme-white"
    },
    NDBenefits: {
        Benefits: "Benefits h-screen relative overflow-hidden NDBenefit",
        mediaItems: "mediaItems",
        backgroundImage: "media bg-image w-full h-screen absolute",
        video: "media absolute",
        textWrapper: "textWrapper w-full pl-25 absolute z-20 bottom-0 pb-29% lg:pb-0 lg:top-0 lg:inset-y-auto lg:right-0 lg:pr-80 lg:pl-0",
        title: "header4 pr-25 lg:pr-0 benefitpdptitle",
        nameSection: "benefitNames header3 mt-1% lg:overflow-hidden lg:mt-2%",
        name: "header-name mr-15 pb-10 lg:relative lg:float-left cursor-pointer lg:pb-12 lg:mr-0 lg:ml-15",
        description: "description body-small mt-3% pr-25 lg:mt-5% lg:pr-0",
        gradientOverlay: "gradientOverlay absolute top-0 left-0 w-full h-full z-10 hidden",
        singleBenefit: "single-benefit",
        black: "theme-black",
        white: "theme-white"
    },
    xoxoBenefitPanel: {
        Benefits: "xoxoBenefitPanel Benefits relative overflow-hidden NDBenefit",
        mediaItems: "mediaItems",
        backgroundImage: "media bg-image w-full h-screen absolute",
        video: "media absolute",
        textWrapper: "textWrapper pl-25 absolute z-20 lg:pr-80 lg:pl-0",
        title: "header3 pr-25 lg:pr-0 benefitpdptitle",
        nameSection: "benefitNames header3 mt-1% lg:overflow-hidden lg:mt-2%",
        name: "header-name mr-15 pb-10 lg:relative lg:float-left cursor-pointer lg:pb-12 lg:mr-0 lg:ml-15",
        description: "description body-small mt-3% pr-25 lg:mt-5% lg:pr-0",
        gradientOverlay: "gradientOverlay absolute top-0 left-0 w-full h-full z-10 hidden",
        singleBenefit: "single-benefit",
        black: "theme-black",
        white: "theme-white"
    },
    GUBenefits: {
        Benefits: "Benefits relative overflow-hidden NDBenefit GUBenefit",
        mediaItems: "mediaItems",
        backgroundImage: "media bg-image w-full h-screen absolute",
        video: "media absolute",
        textWrapper: "textWrapper w-full pl-25 pr-25 absolute z-20 bottom-0 pb-70 lg:pb-0 lg:top-0 lg:inset-y-auto lg:left-0 lg:pl-80 lg:pr-0",
        title: "header4 pr-25 lg:pr-0 benefitpdptitle",
        nameSection: "benefitNames header3 mt-1% lg:mt-2%",
        name: "header-name pb-10 g:pb-12 lg:ml-15",
        description: "body-small mt-3% lg:mt-5% ",
        gradientOverlay: "gradientOverlay absolute top-0 left-0 w-full h-full z-10 hidden",
        singleBenefit: "single-benefit",
        black: "theme-black",
        white: "theme-white"
    },
    kokeshiBenefits: {
        Benefits: "Benefits relative z-20 overflow-hidden NDBenefit kokeshiBenefits",
        mediaItems: "mediaItems",
        backgroundImage: "media bg-image w-full h-screen absolute",
        video: "media absolute",
        textWrapper: "text-center textWrapper absolute z-20 lg:pr-80 px-15 bottom-0 pb-80 lg:pb-0 lg:mb-80 w-full",
        title: "header4 pr-25 lg:pr-0 benefitpdptitle",
        nameSection: "benefitNames header3 mt-1% lg:mt-2%",
        name: "header-name pb-10 lg:relative lg:float-left cursor-pointer lg:pb-12 lg:ml-15",
        description: "body-small mt-3% lg:mt-2% lg:pr-0",
        gradientOverlay: "gradientOverlay absolute top-0 left-0 w-full h-full z-10 hidden",
        singleBenefit: "single-benefit header3",
        black: "theme-black",
        white: "theme-white"
    },
    kokeshiSecondBenefits: {
        Benefits: "Benefits relative z-20 overflow-hidden NDBenefit kokeshiSecondBenefits",
        mediaItems: "mediaItems",
        backgroundImage: "media bg-image w-full h-screen absolute",
        video: "media absolute",
        textWrapper: "text-center textWrapper absolute z-20 lg:left-auto lg:right-3/4 px-15 lg:ml-100 bottom-0 pb-50 w-full",
        title: "header3 lg:pr-0",
        nameSection: "benefitNames header3 mt-1% lg:mt-2%",
        name: "header-name mr-15 pb-10 lg:relative lg:float-left cursor-pointer lg:pb-12 lg:mr-0 lg:ml-15",
        description: "body-small mt-3% pr-25 lg:mt-5% lg:pr-0",
        gradientOverlay: "gradientOverlay absolute top-0 left-0 w-full h-full z-10 hidden",
        singleBenefit: "single-benefit header3",
        black: "theme-black",
        white: "theme-white"
    },
    //TrBenefitsCenterAlign: {
    TRCenterAlign: {
        Benefits: "TRCenter relative",
        mediaItems: "mediaItems",
        backgroundImage: "media bg-image w-full h-screen absolute",
        video: "media absolute",
        //textWrapper: "text-center textWrapper z-20 absolute bottom-0 mb-110 lg:mb-0 lg:top-0 lg:left-0 w-full lg:flex lg:items-center lg:justify-center lg:flex-col overflow-hidden" ,
        //textWrapper: "text-center textWrapper z-20 absolute bottom-0 lg:bottom-100 mb-110 lg:mb-0 lg:top-0 lg:left-0 w-full overflow-hidden",
        textWrapper: "text-center textWrapper z-20 absolute bottom-110 lg:bottom-160 w-full",
        title: "header3 lg:pr-0",
        nameSection: "benefitNames header3 px-25",
        name: "header-name pb-10 lg:relative lg:float-left cursor-pointer lg:pb-30",
        description: "body px-25",
        gradientOverlay: "gradientOverlay absolute top-0 left-0 w-full h-full z-10 hidden",
        singleBenefit: "single-benefit header3 w-full",
        black: "theme-black",
        white: "theme-white"
    },
    TRRightAlign: {
        Benefits: "Benefits relative z-20 overflow-hidden NDBenefit kokeshiBenefits w-full",
        mediaItems: "mediaItems",
        backgroundImage: "media bg-image w-full h-screen absolute",
        video: "media absolute",
        textWrapper: "text-center textWrapper absolute z-20 lg:pr-80 px-15 bottom-0 pb-70 lg:pb-0 lg:mb-80 w-full",
        title: "header3 pr-25 lg:pr-0 benefitpdptitle lg:leading-52",
        nameSection: "benefitNames header3 mt-1% lg:mt-2%",
        name: "header-name pb-10 lg:relative lg:float-left cursor-pointer lg:pb-12 lg:ml-15",
        description: "body mt-3% lg:mt-2% lg:pr-0",
        gradientOverlay: "gradientOverlay absolute top-0 left-0 w-full h-full z-10 hidden",
        singleBenefit: "single-benefit header3",
        black: "theme-black",
        white: "theme-white"
    },
    TRGUERightAlign: {
        Benefits: "Benefits relative z-20 overflow-hidden NDBenefit w-full",
        mediaItems: "mediaItems",
        backgroundImage: "media bg-image w-full h-screen absolute",
        video: "media absolute",
        textWrapper: "text-center textWrapper absolute z-20 lg:pl-55 px-15 bottom-0 top-80 lg:mt-230 min-h-480 pb-70 lg:pb-0 lg:mb-80 w-full",
        title: "header3 pr-25 lg:pr-0 benefitpdptitle lg:leading-52",
        nameSection: "benefitNames header3 mt-1% lg:mt-2%",
        name: "header-name pb-10 lg:relative lg:float-left cursor-pointer lg:pb-12 lg:ml-15",
        description: "body mt-3% lg:mt-2% lg:pr-0",
        gradientOverlay: "gradientOverlay absolute top-0 left-0 w-full h-full z-10 hidden",
        singleBenefit: "single-benefit header3",
        black: "theme-black",
        white: "theme-white"
    },
    hainanBenifits: {
        Benefits: "Benefits relative z-20 overflow-hidden NDBenefit kokeshiBenefits w-full",
        mediaItems: "mediaItems",
        backgroundImage: "media bg-image w-full h-screen absolute",
        video: "media absolute",
        textWrapper: "text-center textWrapper absolute z-20 lg:pr-80 px-15 bottom-0 pb-55 lg:pb-0 lg:mb-80 w-full",
        title: "header3 benefitpdptitle lg:leading-52",
        nameSection: "benefitNames header3 mt-1% lg:mt-2%",
        name: "header-name pb-10 lg:relative lg:float-left cursor-pointer lg:pb-12 lg:ml-15",
        description: "body mt-3% lg:mt-2% lg:pr-0",
        gradientOverlay: "gradientOverlay absolute top-0 left-0 w-full h-full z-10 hidden",
        singleBenefit: "single-benefit header3",
        black: "theme-black",
        white: "theme-white"
    },
    CelebrityKv: {
        Benefits: "Benefits relative z-20 overflow-hidden NDBenefit kokeshiBenefits w-full",
        mediaItems: "mediaItems",
        backgroundImage: "media bg-image w-full h-screen absolute",
        video: "media absolute",
        textWrapper: "text-center textWrapper absolute z-20 lg:pr-80 px-15 bottom-0 pb-50 lg:pb-0 lg:mb-80 w-full",
        title: "header3 lg:pr-0 benefitpdptitle lg:leading-52",
        nameSection: "benefitNames header3 mt-1% lg:mt-2%",
        name: "header-name pb-10 lg:relative lg:float-left cursor-pointer lg:pb-12 lg:ml-15",
        description: "body mt-3% lg:mt-2% lg:pr-0",
        gradientOverlay: "gradientOverlay absolute top-0 left-0 w-full h-full z-10",
        singleBenefit: "single-benefit header3",
        black: "theme-black",
        white: "theme-white"
    },
    darkCircle: {
        Benefits: "Benefits relative overflow-hidden",
        mediaItems: "mediaItems",
        backgroundImage: "media bg-image w-full h-screen lg:h-710 absolute",
        video: "media absolute",
        textWrapper: "text-center darkCircle textWrapper w-full px-25 absolute z-20 bottom-0 pb-85 lg:pb-0 lg:top-0 lg:inset-y-auto lg:right-0 lg:pr-80 lg:pl-0",
        title: "header4 pr-25 lg:pr-0 benefitpdptitle",
        nameSection: "benefitNames header1 mt-1% lg:overflow-hidden lg:mt-2%",
        name: "header3 mr-15 pb-10 lg:relative cursor-pointer lg:pb-12 lg:ml-0",
        description: "description body-small mt-3% pr-25 lg:pr-0 lg:pb-10 mx-auto",
        gradientOverlay: "gradientOverlay absolute top-0 left-0 w-full h-full z-10",
        singleBenefit: "single-benefit",
        black: "theme-black",
        white: "theme-white",
        imgStyle: ""
    },
    gae: {
        Benefits: " gae Benefits relative overflow-hidden",
        mediaItems: "mediaItems",
        backgroundImage: "media bg-image w-full h-screen lg:h-710 absolute",
        video: "media absolute",
        textWrapper: "darkCircle textWrapper gae-hk w-full pl-25 absolute z-20 bottom-0 pb-30 lg:pb-0 lg:top-0 lg:inset-y-auto lg:pr-80 lg:pl-180 lg:flex lg:flex-col lg:justify-center text-center lg:text-left ",
        title: "header3 pr-25 lg:pr-0",
        nameSection: "benefitNames header1 mt-1% lg:overflow-hidden lg:mt-2%",
        name: "header-name mr-15 pb-10 lg:relative lg:float-left cursor-pointer lg:pb-12 lg:mr-15 lg:ml-0",
        description: "description body-small font-normal mt-3% pr-25 lg:mt-5% lg:pr-0 lg:absolute lg:bottom-30",
        gradientOverlay: "gradientOverlay absolute top-0 left-0 w-full h-full z-10",
        singleBenefit: "single-benefit",
        black: "theme-black",
        white: "theme-white",
        imgStyle: ""
    },
    guecCn: {
        Benefits: " gae Benefits relative overflow-hidden",
        mediaItems: "mediaItems",
        backgroundImage: "media bg-image w-full h-screen lg:h-710 absolute",
        video: "media absolute",
        textWrapper: "darkCircle textWrapper gae-hk w-full pl-25 absolute z-20 bottom-0 pb-30 lg:pb-0 lg:top-0 lg:inset-y-auto lg:pr-80 lg:pl-180 lg:flex lg:flex-col lg:justify-center text-center lg:text-left ",
        title: "header3 pr-25 lg:pr-0",
        nameSection: "benefitNames header1 mt-1% lg:overflow-hidden lg:mt-2%",
        name: "header-name mr-15 pb-10 lg:relative lg:float-left cursor-pointer lg:pb-12 lg:mr-15 lg:ml-0",
        description: "description body-small font-normal mt-3% pr-25 lg:mt-5% lg:pr-0 lg:relative lg:bottom-0",
        gradientOverlay: "gradientOverlay absolute top-0 left-0 w-full h-full z-10",
        singleBenefit: "single-benefit",
        black: "theme-black",
        white: "theme-white",
        imgStyle: ""
    }
});

// EXTERNAL MODULE: ./components/Product/RichText/Richtext.js + 1 modules
var Richtext = __webpack_require__(2327);
// EXTERNAL MODULE: ./components/Carousel/Carousel.js
var Carousel = __webpack_require__(3174);
;// CONCATENATED MODULE: ./components/Carousel/index.js


// EXTERNAL MODULE: ./constants/global.js
var global = __webpack_require__(5379);
// EXTERNAL MODULE: ./components/Product/Disclaimer/Disclaimer.js + 1 modules
var Disclaimer = __webpack_require__(9991);
// EXTERNAL MODULE: ./components/Product/Typography/Typography.js
var Typography = __webpack_require__(8766);
// EXTERNAL MODULE: ../node_modules/prop-types/index.js
var prop_types = __webpack_require__(3615);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./components/Button/Button.js
var Button = __webpack_require__(8506);
// EXTERNAL MODULE: ./adapters/cloudinary.adapters.js
var cloudinary_adapters = __webpack_require__(6508);
;// CONCATENATED MODULE: ./components/Product/Benefits/Benefits.js








const BackgroundImage = dynamic_default()(()=>__webpack_require__.e(/* import() */ 8938).then(__webpack_require__.bind(__webpack_require__, 8938)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(8938)
            ]
    }
});
const Video = dynamic_default()(()=>__webpack_require__.e(/* import() */ 1259).then(__webpack_require__.bind(__webpack_require__, 1259)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(1259)
            ]
    }
});






const Hammer =  true ? __webpack_require__(3718) : 0;
class Benefits extends react.Component {
    componentDidUpdate(prevProps, prevState) {
        const { state: { currentIndex  } , props: { scrollMagicEvent  } , mediaRefs , nameRefs , changeSelected , windowWidth , playVideo , benefitsCount  } = this;
        const { currentIndex: prevIndex  } = prevState;
        if (currentIndex != prevState.currentIndex) {
            changeSelected(mediaRefs, prevIndex, currentIndex);
            if (windowWidth >= global.breakpoints.sP || benefitsCount === 1) {
                changeSelected(nameRefs, prevIndex, currentIndex);
            }
        }
        if (currentIndex != prevState.currentIndex || scrollMagicEvent && scrollMagicEvent.type === "start" && prevProps.scrollMagicEvent.timestamp != scrollMagicEvent.timestamp) {
            const currentMedia = mediaRefs[currentIndex];
            if (currentMedia && currentMedia.tagName === "VIDEO") {
                playVideo(currentMedia);
            }
            if (currentIndex != prevState.currentIndex) {
                window.dataLayer.push({
                    event: "customEvent",
                    GAeventCategory: "event_informational_action",
                    GAeventAction: "event_view_more_details",
                    GAeventLabel: "Benefit Carousel_".concat(currentIndex + 1)
                });
            }
        }
    }
    componentDidMount() {
        const { windowWidth , addSwipe , benefitsCount  } = this;
        if (windowWidth < global.breakpoints.sP && benefitsCount > 1) {
            addSwipe();
        }
    }
    render() {
        var ref, ref1, ref2, ref3, ref4;
        const styles = Benefits_tw_styles[this.benefitSection.styles || "default"] || Benefits_tw_styles["default"];
        const { Benefits: benefitsStyle , mediaItems , nameSection , description , title , textWrapper , gradientOverlay , disclaimer , black , imgStyle  } = styles;
        const { benefitData , getBenefitMedia , windowWidth , flickityOptions , getBenefitNames , setCarouselRef , setBenefitRef , benefitSection , benefitsCount , sectionClickHandler , state: { currentIndex  }  } = this;
        let themeKey = "";
        if (benefitSection.mobileThemeColor && windowWidth < global.breakpoints.sP) {
            themeKey = benefitSection.mobileThemeColor;
        } else if (benefitSection.themeColor) {
            themeKey = benefitSection.themeColor;
        }
        const theme = themeKey ? styles[themeKey] : black;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            role: "presentation",
            className: classnames_default()(benefitsStyle, theme),
            ref: (ref)=>setBenefitRef(ref),
            onClick: sectionClickHandler,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: mediaItems,
                    children: benefitData.items[0].media && this.benefitSection.uniqueImage ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("picture", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                                src: (0,cloudinary_adapters/* getImageUrl */.Jn)(benefitData.items[0].media.desktopImage.url),
                                srcSet: (0,cloudinary_adapters/* getSrcSet */.gA)(benefitData.items[0].media.desktopImage.url, 1024),
                                media: "(min-width:1024px)"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                className: imgStyle ? imgStyle : "",
                                src: (0,cloudinary_adapters/* getImageUrl */.Jn)(benefitData.items[0].media.smartphoneImage.url),
                                alt: benefitData.items[0].media.altText
                            })
                        ]
                    }) : benefitData.items.map((benefit, index)=>benefit.media && getBenefitMedia(benefit.media, index))
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: gradientOverlay
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: textWrapper,
                    children: [
                        benefitSection.title && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography["default"], {
                            component: (benefitSection === null || benefitSection === void 0 ? void 0 : benefitSection.headingType) || "h2",
                            className: title,
                            children: benefitSection.title
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: nameSection,
                            children: windowWidth < global.breakpoints.sP && benefitsCount > 1 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Carousel_namespaceObject["default"], {
                                options: flickityOptions,
                                className: "slider",
                                flickityRefCallback: (ref)=>setCarouselRef(ref),
                                children: getBenefitNames()
                            }) : getBenefitNames()
                        }),
                        benefitData.items[currentIndex].description && /*#__PURE__*/ (0,jsx_runtime.jsx)(Richtext["default"], {
                            className: description,
                            richTextJson: benefitData.items[currentIndex].description
                        }, currentIndex),
                        benefitData.items[currentIndex].disclaimer && /*#__PURE__*/ (0,jsx_runtime.jsx)(Disclaimer["default"], {
                            classKey: disclaimer,
                            theme: themeKey,
                            content: benefitData.items[currentIndex].disclaimer
                        }),
                        ((ref = benefitData === null || benefitData === void 0 ? void 0 : benefitData.items[currentIndex]) === null || ref === void 0 ? void 0 : ref.cta) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button["default"], {
                            href: (ref1 = benefitData.items[currentIndex]) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.cta) === null || ref2 === void 0 ? void 0 : ref2.link,
                            className: "how-to-use-btn",
                            children: (ref3 = benefitData.items[currentIndex]) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.cta) === null || ref4 === void 0 ? void 0 : ref4.linkText
                        })
                    ]
                })
            ]
        });
    }
    constructor(props){
        super(props);
        (0,_define_property/* default */.Z)(this, "setMediaRef", (ref, index)=>{
            this.mediaRefs[index] = ref;
        });
        (0,_define_property/* default */.Z)(this, "setNameRef", (ref, index)=>{
            this.nameRefs[index] = ref;
        });
        (0,_define_property/* default */.Z)(this, "setBenefitRef", (ref)=>{
            this.benefitRef = ref;
        });
        (0,_define_property/* default */.Z)(this, "setCarouselRef", (flickityObj)=>{
            this.carouselRef = flickityObj;
            this.carouselRef.resize();
            this.carouselRef.on("settle", (index)=>{
                this.handleClick(index);
            });
        });
        (0,_define_property/* default */.Z)(this, "addSwipe", ()=>{
            const { benefitRef , isChild  } = this;
            const styles = Benefits_tw_styles[this.benefitSection.styles || "default"] || Benefits_tw_styles["default"];
            const { nameSection  } = styles;
            const benefitNamesUniqueClass = nameSection.split(" ")[0];
            if (Hammer && benefitRef) {
                const hammerInst = new Hammer.Manager(benefitRef, {
                    recognizers: [
                        [
                            Hammer.Swipe,
                            {
                                direction: Hammer.DIRECTION_HORIZONTAL
                            }
                        ]
                    ]
                });
                const benefitNamesElem = document.querySelector(".".concat(benefitNamesUniqueClass));
                hammerInst.on("swiperight", (e)=>{
                    if (!isChild(benefitNamesElem, e.target)) {
                        this.carouselRef.previous();
                    }
                });
                hammerInst.on("swipeleft", (e)=>{
                    if (!isChild(benefitNamesElem, e.target)) {
                        this.carouselRef.next();
                    }
                });
            }
        });
        (0,_define_property/* default */.Z)(this, "isChild", (parent, child)=>{
            return parent !== child && parent.contains(child);
        });
        (0,_define_property/* default */.Z)(this, "getBenefitMedia", (media, index)=>{
            const styles = Benefits_tw_styles[this.benefitSection.styles || "default"] || Benefits_tw_styles["default"];
            const { backgroundImage , video  } = styles;
            const { setMediaRef  } = this;
            switch(media.__typename){
                case "ImageSet":
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(BackgroundImage, {
                        className: classnames_default()(backgroundImage, {
                            "is-selected": index === 0
                        }),
                        setImageRef: (ref)=>setMediaRef(ref, index),
                        lazyLoad: true,
                        tag: "div",
                        image: media
                    }, media.sys.id);
                case "Videos":
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Video, {
                        classKey: classnames_default()(video, {
                            "is-selected": index === 0
                        }),
                        setVideoRef: (ref)=>setMediaRef(ref, index),
                        videoData: media,
                        lazyLoad: true
                    }, media.sys.id);
                default:
            }
        });
        (0,_define_property/* default */.Z)(this, "handleClick", (currentIndex)=>{
            this.setState({
                currentIndex
            });
        });
        (0,_define_property/* default */.Z)(this, "changeSelected", (refs, prevIndex, currIndex)=>{
            const prevEl = refs[prevIndex];
            const currEl = refs[currIndex];
            prevEl.classList.remove("is-selected");
            currEl.classList.add("is-selected");
        });
        (0,_define_property/* default */.Z)(this, "playVideo", (video)=>{
            if (video && video.paused) {
                video.play();
                video.onended = ()=>{
                    video.play();
                };
            }
        });
        (0,_define_property/* default */.Z)(this, "getBenefitNames", ()=>{
            const { benefitData , handleClick , setNameRef , windowWidth , carouselRef , benefitsCount  } = this;
            const styles = Benefits_tw_styles[this.benefitSection.styles || "default"] || Benefits_tw_styles["default"];
            const { name , singleBenefit  } = styles;
            return benefitData.items.map((benefit, index)=>benefit.name && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography["default"], {
                    component: this.benefitSection.title ? "h3" : "h2",
                    className: classnames_default()(name, {
                        "is-selected": index === 0
                    }, {
                        [singleBenefit]: benefitsCount === 1
                    }),
                    setTypoRef: (ref)=>setNameRef(ref, index),
                    tabIndex: benefitsCount > 1 ? 0 : "-1",
                    role: "button",
                    onClick: ()=>windowWidth < global.breakpoints.sP && benefitsCount > 1 ? carouselRef.select(index) : handleClick(index),
                    onKeyDown: (e)=>{
                        if (e.key === "Enter" || e.key === " ") {
                            e.preventDefault();
                            handleClick(index);
                        }
                    },
                    children: benefit.name
                }, index));
        });
        (0,_define_property/* default */.Z)(this, "sectionClickHandler", (e)=>{
            const { windowWidth , carouselRef , isChild , benefitRef , benefitsCount  } = this;
            const styles = Benefits_tw_styles[this.benefitSection.styles || "default"] || Benefits_tw_styles["default"];
            const { nameSection  } = styles;
            const benefitNamesUniqueClass = nameSection.split(" ")[0];
            const benefitNamesElem = document.querySelector(".".concat(benefitNamesUniqueClass));
            if ( true && windowWidth < global.breakpoints.sP && benefitsCount > 1 && !isChild(benefitNamesElem, e.target)) {
                const pWidth = benefitRef.offsetWidth;
                pWidth / 2 > e.pageX ? carouselRef.previous() : carouselRef.next();
            }
        });
        this.benefitSection = props.content;
        this.benefitData = this.benefitSection.benefitsCollection;
        this.benefitsCount = this.benefitData.items.length;
        this.mediaRefs = [];
        this.nameRefs = [];
        this.carouselRef = null;
        this.benefitRef = null;
        if (true) {
            this.windowWidth = window.innerWidth;
        }
        this.flickityOptions = {
            cellAlign: "left",
            pageDots: false,
            selectedAttraction: 0.2,
            friction: 0.9,
            dragThreshold: 1
        };
        this.state = {
            currentIndex: 0
        };
    }
}
Benefits.propTypes = {
    content: (prop_types_default()).object,
    scrollMagicEvent: prop_types_default().oneOfType([
        (prop_types_default()).object,
        (prop_types_default()).string
    ])
};
/* harmony default export */ var Benefits_Benefits = (Benefits);


/***/ }),

/***/ 9991:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Disclaimer_Disclaimer; }
});

// EXTERNAL MODULE: ../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(4246);
// EXTERNAL MODULE: ../node_modules/react/index.js
var react = __webpack_require__(7378);
;// CONCATENATED MODULE: ./styles/components/Product/Disclaimer/Disclaimer-tw-styles.js
/* harmony default export */ var Disclaimer_tw_styles = ({
    disclaimer: "Disclaimer disclaimer-text mt-12",
    text: "",
    white: "theme-white",
    black: "theme-black",
    grey: "theme-grey"
});

// EXTERNAL MODULE: ./components/Product/RichText/Richtext.js + 1 modules
var Richtext = __webpack_require__(2327);
// EXTERNAL MODULE: ../node_modules/prop-types/index.js
var prop_types = __webpack_require__(3615);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
;// CONCATENATED MODULE: ./components/Product/Disclaimer/Disclaimer.js





const Disclaimer = (param)=>{
    let { content , theme , classKey  } = param;
    const { disclaimer , text , black  } = Disclaimer_tw_styles;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "".concat(disclaimer, " ").concat(theme ? Disclaimer_tw_styles[theme] : black, " ").concat(classKey ? classKey : ""),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Richtext["default"], {
            className: text,
            richTextJson: content
        })
    });
};
Disclaimer.propTypes = {
    content: (prop_types_default()).object,
    theme: (prop_types_default()).string,
    classKey: (prop_types_default()).string
};
/* harmony default export */ var Disclaimer_Disclaimer = (Disclaimer);


/***/ })

}]);